module.exports = __webpack_public_path__ + "img/index_more_red.686289a0.svg";